export default __webpack_public_path__ + "static/media/plus.7d8edb57.svg";